<template>
	<header class="header">
        <div class="logo" @click="() => { jump('/') }">
            小盒科技
        </div>
        <div class="nav">
            <div class="list">
                <span class="link" :class="{cur: cur === item.url}" v-for="(item, index) in navList" :key="index" @click="() => { jump(item.url) }">
                    {{item.name}}
                </span>
            </div>
        </div>
	</header>
</template>

<script>
    import { Component, Watch, Vue } from "vue-property-decorator";
    import { getCommonInfo } from '@/api/common.js';
    import { EventBus } from '@/utils/eventBus.js';
    import { scrollToTop, checkUserAgent, resize, coordMaps } from '@/utils/index.js';

	@Component
	export default class Header extends Vue {
        cur = '';
        navList = [
            {
                name: '首页',
                url: '/'
            }, {
                name: '关于小盒',
                url: '/about'
            },
            //  {
            //     name: '小盒产品',
            //     url: '/product'
            // },
             {
                name: '小盒新闻',
                url: '/news'
            }, {
                name: '加入小盒',
                url: '/join'
            }
        ];

        @Watch('$route', { immediate: true, deep: true })
        onUrlChange(val, old) {
            let coord = 0;

            if (val.query.block) {
                coord = coordMaps[val.query.block];
            }

            scrollToTop(coord);
        }

        async created() {
            resize();
            checkUserAgent();

            window.addEventListener('resize', () => {
                checkUserAgent();
            });

            const { code, data, msg } = await getCommonInfo();

            if (code === 0) {
                this.$store.dispatch('common/setData', data);
            } else {
                console.log(msg);
            }
        }

        jump(url = '/') {
            this.cur = url;

            this.$router.push({
                path: `${url}` 
            });

            if (this.$route.path === url) {
                scrollToTop();
            }
        }

        loginTeacherWeb() {
            window.open('https://teacher.knowbox.cn');
        }

        mounted() {
            const path = location.pathname;
            
            this.cur = path;

            EventBus.$on('router.change', cur => {
                if(cur==='/about?block=leader'){
                    this.cur = '/about'
                } else {
                    this.cur = cur;
                }
            });
        }
	}
</script>

<style lang="scss">
    .header {
        width: 100%;
        height: 100px;
        padding: 0 100px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #e5e5e5;
        position: fixed;
        background: #fff;
        z-index: 9999;
        .logo {
            width: 141px;
            height: 50px;
            background: url(https://susuanqiniu.knowbox.cn/fe/www-m/xhkt-logo-pc.png) no-repeat;
            background-size: 100% 100%;
            text-indent: -9999px;
            cursor: pointer;
        }
        .nav {
            display: flex;
            align-items: center;
            .list {
                width: 400px;
                display: flex;
                justify-content: space-between;
                color: #3F3F43;
                font-size: 26px;
                .link {
                    color: #3F3F43;
                    font-size: 16px;
                    text-decoration: none;
                    border-bottom: 1px solid transparent;
                    padding: 10px 0;
                    box-sizing: border-box;
                    cursor: pointer;
                    font-family: PingFangSC-light;
                    &.cur,
                    &:hover {
                        border-bottom: 1px solid #E65C29;
                        color: #E65C29;
                    }
                }
            }
            .teacher {
                // width: 90px;
                height: 30px;
                line-height: 30px;
                // background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/computer-2.png) #FB5000 center center no-repeat;
                margin-left: 30px;
                color: #fff;
                background: #fa5000;
                padding: 0 10px;
                font-size: 13px;
                cursor: pointer;
                margin-top: -3px;
                font-family: PingFangSC-light;
            }
        }
    }
</style>
